import React from 'react';
import { MapPin, Eye } from 'lucide-react';
import { Button } from '../ui/button';

const ProjectCard = ({ title, client, location, status, image, value, onView }) => {
  return (
    <div 
      className="group relative h-[400px] rounded-xl overflow-hidden cursor-pointer"
      data-aos="fade-up"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src={image || "https://images.unsplash.com/photo-1693661391267-ad955aeeb564?q=80&w=2070&auto=format&fit=crop"} 
          alt={title} 
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/80 to-transparent opacity-90 group-hover:opacity-80 transition-opacity duration-500"></div>
      </div>

      {/* Content */}
      <div className="absolute inset-0 p-8 flex flex-col justify-end">
        <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
          <div className="flex justify-between items-start mb-2">
            <span className={`px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider ${status === 'Ongoing' ? 'bg-primary text-background' : 'bg-white/20 text-white backdrop-blur-sm'}`}>
              {status}
            </span>
            {value && <span className="text-primary font-bold">{value}</span>}
          </div>
          
          <h3 className="text-2xl font-serif font-bold text-white mb-2 group-hover:text-primary transition-colors duration-300">
            {title}
          </h3>
          
          <div className="space-y-1 mb-4 opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100">
            <p className="text-white/80 text-sm flex items-center gap-2">
              <span className="text-primary font-semibold">Client:</span> {client}
            </p>
            <p className="text-white/80 text-sm flex items-center gap-2">
              <MapPin size={14} className="text-primary" /> {location}
            </p>
          </div>
          
          <div className="h-1 w-0 bg-primary group-hover:w-full transition-all duration-700"></div>

          {onView && (
            <Button
              onClick={onView}
              className="mt-4 opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-200 bg-primary hover:bg-primary/90 text-background"
              size="sm"
            >
              <Eye className="w-4 h-4 mr-2" />
              View Project
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
